<template>
  <div>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7428 8.92243C13.0682 9.24786 13.5958 9.24786 13.9213 8.92243C14.2467 8.59699 14.2467 8.06935 13.9213 7.74391L10.588 4.41058C10.2625 4.08514 9.73488 4.08514 9.40944 4.41058L6.07611 7.74391C5.75067 8.06935 5.75067 8.59699 6.07611 8.92243C6.40155 9.24786 6.92918 9.24786 7.25462 8.92243L9.9987 6.17835L12.7428 8.92243Z"
        fill="#4D4D4D"
      />
      <path
        d="M7.25462 11.0772C6.92918 10.7518 6.40155 10.7518 6.07611 11.0772C5.75067 11.4027 5.75067 11.9303 6.07611 12.2558L9.40944 15.5891C9.73488 15.9145 10.2625 15.9145 10.588 15.5891L13.9213 12.2558C14.2467 11.9303 14.2467 11.4027 13.9213 11.0773C13.5959 10.7518 13.0682 10.7518 12.7428 11.0772L9.9987 13.8213L7.25462 11.0772Z"
        fill="#4D4D4D"
      />
    </svg>
  </div>
</template>

<script>
import { Vue } from "vue-class-component";

export default class SortTransferPickup extends Vue {}
</script>
